import { render, staticRenderFns } from "./AuthBase.vue?vue&type=template&id=3a4f37bc"
import script from "./AuthBase.vue?vue&type=script&lang=js"
export * from "./AuthBase.vue?vue&type=script&lang=js"
import style0 from "./AuthBase.vue?vue&type=style&index=0&id=3a4f37bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports